import { Image, get_prop } from 'utils'
import { balls, mini_balls } from './balls'
import { TYPE, canGo, canOnlyGo } from 'network/server_tool'
import lines from './lines'
import { SlotMath } from 'slot-math'
import { REQUEST_TYPE } from 'network/net'
import { regular_game_wins_presentation, frames, lines_win_display_billets_fix } from './win_presentation'//from 'slot_presentation'
import SlotWinPresenter from 'slot_win_presenter'
import { rows_count } from 'utils'
import Game from 'game'
import ui_view from './ui_view'
import Texts from './texts'
import table from './table'
import mini_cheque from './small_table';
import RiskView from 'risk_view'
import Risk from './risk'
import { Animation } from 'animation'
import Help from './help';//import { HelpScene } from 'helpscene'
import small_ticket from './small_ticket'
import freegames from './freegames'
import { FAKE_TERMINAL_ID } from 'main'

import {to_literal_text} from'./ui_view';

export function getMinorUnitText(value, space) {
    return to_literal_text(value, space.s('balance').value)
}

export const WIDTH = 1576
export const HEIGHT = 885
export function center( image ) {
    image.anchor.set( 0.5 )
    image.position.set( WIDTH / 2, HEIGHT / 2 )
}

/** Абстрактная игра "Шары". Всегда вызывается. В каждой конкретной игре поведение можно изменять внутри reactive().*/
export default function( app, spec, settings )
{
    const space = app.space
    
    const s = spec.specification
    const math = new SlotMath( {
        lines: s.linesCountMax,
        symbols: s.symbolsCount,
        wild: s.symbolWild,
        scatter: s.symbolScatter,
        
        trajectories: s.linesPaths,
        price: s.priceList,
        scatterPrice: s.scatterWinCoeffs,
        substitutableElements: s.substitutableElements,
        wildLineWinMultiplier: s.wildLineWinMultiplier,
        freegamesMultiplier: s.freeSpinWinMultiplier,
        winShapes: s.winShapes,
    } )
    space.s( 'sportbet:math' ).next( math )
    space.s( 'math' ).next( math )
    
    settings.slot.barrel.rows = rows_count( spec )
    settings.slot.barrel.reels = s.linesPaths ? s.linesPaths[ 0 ].length : 0
    
    const container = app.container
    
    const under = Image( settings.slot.underScreen )
    under.position.set( settings.slot.underScreenPos.x, settings.slot.underScreenPos.y )
    container.addChild( under )
    
    const presenter = new SlotWinPresenter( math, settings.slot, undefined, space )
    presenter.hideBarrelElement = ()=>{}
    presenter.showBarrelElement = ()=>{}
    
    const balls_container = new PIXI.Container
    container.addChild( balls_container )
    balls( space, balls_container, settings )
    
    container.addChild( Image( settings.slot.background ) )
    if (settings.slot.systemaTextColor !== undefined) {
        const systema = new PIXI.Text('Система+', {
            fontSize: 14,
            fontWeight: 'bold',
            fill: settings.slot.systemaTextColor
        })
        systema.position.set( 557, 93 )
        container.addChild( systema )
    }
    
    const terminal = new PIXI.Text( '', { fontSize : 14, fill : settings.slot.terminalTextColor, align : 'center' } )
    terminal.anchor.set( 0.5, 0 )
    terminal.position.set( 1380, 730 )
    container.addChild( terminal )
    space.s( 'terminal_id' ).on( id => terminal.text = 'Терминал № ' + id.toString() )

    const presenter_container = new PIXI.Container();
    container.addChild(presenter_container);
    lines( space, presenter_container, spec, settings.slot, presenter )
    
    regular_game_wins_presentation( space, undefined, presenter, math )
    space.s( 'sportbet:balls_rolled' ).to( space.s( 'barrel:stop' ) )

    presenter_container.addChild( presenter )
    frames( space, presenter_container, spec, settings.slot )
    
    //table view:
    const table_container = new PIXI.Container
    container.addChild( table_container )
    table( space, table_container, spec, settings )
    
    space.s( 'keyboard' )
        .filter( k => k == 49 /* 1 */ )
        .to( space.s( 'ui:button_visual_mode_click' ) )
    space.s( 'ui:button_visual_mode_click' )
        .with( space.s( 'sportbet:table_mode' ), ( _, tm ) => tm )
        .map( tm => ! tm )
        .to( space.s( 'sportbet:table_mode' ) )
    space.s( 'sportbet:table_mode' ).on( tm => {
        table_container.visible = tm
        presenter_container.visible = balls_container.visible = ! tm
    } )

    mini_cheque(space, container, spec, settings);
    
    const miniballs_container = new PIXI.Container
    container.addChild( miniballs_container )
    mini_balls( space, miniballs_container, settings )
    space.s( 'state' )
        //искусственная зависимость от стрима чтобы сортировка сообщений в стримах обработала этот стрим ПОСЛЕ того как сработает Укатывание шаров (когда перейдём на функциональный язык, где выполнение функций реализовано путём решения системы уравнений, то такая проблема сама-собой исчезнет ;) ):
        .with( space.s( 'sportbet:pending_rollout' ), state => state )
        .map( state => [ TYPE.REGULAR, TYPE.FREEGAME ].includes( state.state.stage.type_id ) ? state : undefined )
        .to( space.s( 'sportbet:pending_rollout' ) )
    //wait for rolling away balls:
    space.s( 'sportbet:pending_rollout' )
        .any( space.s( 'sportbet:roll_away' ), ( p, a ) => p && ! a ? p : undefined )
        .filter( p => p )
        .to( space.s( 'sportbet:rollout' ) )
    //start to roll away:
    space.s( 'state' )
        .filter( state => [ TYPE.REGULAR, TYPE.FREESPIN ].includes( state.type ) )
        .map( () => true )
        .to( space.s( 'sportbet:roll_away' ) )
    
    const help = new Help(settings, space);//new HelpScene( undefined, undefined, math, settings.help )
    
    Game(
        space,
        {
            help,
        },
        { lines : spec.lines_array, multipliers : spec.bets_array },
        undefined,
        spec,
    )

    const ui_view_r = ui_view({
        uiConfig : settings.ui,
        helpConfig : settings,
        parent : space,
        always_interactive_container : container,
        spec,
    })
    
    space.s( "slot:initial" ).on( ({ lines, multiplier }) => {
        for ( let i = 0; i < lines; ++ i ) presenter.showActiveBillets( i )
        for ( let i = lines; i < math.linesNumber(); ++ i ) presenter.hideActiveBillets( i )
    } )
    
    space.s( 'pending' ).to( space.s( 'slot:interruptWinShow' ) )
    space.s( 'slot:interruptWinShow' ).on( () => presenter.interruptShowWin( presenter, math ) )
    
    space.s( 'presenter:done_playing_wins' )
        .with( space.s( 'state' ), ( _, state ) => state )
        .filter( state => state.type == TYPE.REGULAR )
        .to( space.s( 'slot:showWinComplete' ) )
    
    space.s( "slot:showWin" )
        .with( space.s( 'state' ), ( _, state ) => state )
        .map( state => state.state.stage.win * state.state.multiplier )
        .to( space.s( 'balance:winFlowUp' ) )

    //остановим натекание выигрыша в фри при начале нового спина
    space.s( "request" )
        .with(space.s('state'), (request, state) => ({request, state}))
        .filter(({request, state}) => (canGo( TYPE.FREEGAME, state.state ) && request.type == REQUEST_TYPE.PROCEED))
        .map(({request, state}) => state)
        .to(space.s('balance:replicate'))

    //в оригинале перед началом фри спина зачем то вычитается ставка из выигрыша, а потом возвращается
    //пробуем повторить
    /*space.s( "request" )
        .delay(0)
        .with(space.s('state'), (request, state) => ({request, state}))
        .filter(({request, state}) => (canGo( TYPE.FREEGAME, state.state ) && request.type == REQUEST_TYPE.PROCEED))
        .map(({request, state}) => state)
        .with(space.s('ui:win'), space.s('ui:price'), (state, win, bet) => win - bet)
        .to(space.s('ui:win'));

    space.s( 'barrel:stop' )
        .with(space.s('state'), (_, state) => state)
        .filter(state => state.type && state.type == TYPE.FREEGAME)
        .with(space('balance:winFlow'), (state, win) => win)
        .to(space.s('ui:win'));*/
    
    Texts( space, container, settings )
    
    freegames( space, container )
    
    //risk:
    const risk_container = new PIXI.Container();
    Risk( space, risk_container, settings )
    RiskView( risk_container, space, space.s( 'ticker' ) )
    container.addChild( risk_container )
    
    small_ticket( space, container, spec, settings )

    space.s( 'sportbet:table_mode' ).next( true )
    
    //"preloading" animation on network activity:
    const preloader = Image( 'res/games/preloader.png' )
    center( preloader )
    container.addChild( preloader )
    space.s( 'ticker' ).on( s => preloader.rotation += s * 2 )
    space.s( 'pending' )
        .with( space.s( 'state' ), ( p, s ) => ({ p, s }) )
        .on( ({ p, s }) => preloader.visible = 
            ( p == REQUEST_TYPE.SPIN )
            ||
            ( s.type == TYPE.FREESPIN && p == REQUEST_TYPE.PROCEED )
            ||
            ( p && s.type == TYPE.RISK_MAIN )
        )

    container.addChild( help )

    container.addChild( ui_view_r.ui )

    setTimeout(() => {
        space.s('game_can_show').next();
    }, 0)
}


export const GAME_SETTINGS = {
    slot : {
        background: 'res/games/screen.png',
        underScreen: 'res/games/under_screen.png',
        underScreenPos: {x: 62, y: 123},
        barrel: {
            position : { x : 66, y : 125 },
            positions_x : [ 66, 279, 493, 706, 920 ],
            cellSize : { width : 213, height : 197 },
        },
        
        balls : 'res/games/balls/{symbol}/{symbol}_%03d.png',
        mini_balls_rotating : 'res/games/mini_balls/{symbol}_00.png',
        mini_balls_flash : 'res/games/mini_balls/{symbol}_01.png',

        a1_a15 : 'res/games/a1_a15.png',

        roll_music: 'res/games/sounds/balls_roll_music',
        ball_away_sound: 'res/games/sounds/balls_away',
        ball_stop_sound: 'res/games/sounds/ball_end_roll',

        symbol_animation_filename_pattern : 'res/games/balls/%d/%d',
        symbol_animation_filename_pattern_postfix : '_%03d.png',
        //animation_frames_count: 3,
        symbol_animation_sequence : [ 6, 7, 8, 7, 6 ],
        animation_frame_delay : 0.05,
        
        lines_pattern : 'res/games/lines/line_%02d.png',
        lines_position : [
            [ 42, 407 ],
            [ 42, 213 ],
            [ 42, 603 ],
            [ 43, 148 ],
            [ 43, 141 ],
            [ 42, 278 ],
            [ 42, 274 ],
            [ 42, 180 ],
            [ 42, 345 ],
        ],

        lines_sound_pattern: 'res/games/sounds/lines_',
        
        frames_template : 'res/games/frames/c%02d.png',
        frames_disp : { x : -7, y : -6 },

        scatter_frame: 'res/games/frames/c03.png',
        
        left_billets_on_filename_pattern : 'res/games/billets/pl%02d.png',
        right_billets_on_filename_pattern : 'res/games/billets/pl%02d.png',
        left_billets_coords: [
            {x:8, y:395},
            {x:8, y:200},
            {x:8, y:589},
            {x:8, y:135},
            {x:8, y:654},
            {x:8, y:265},
            {x:8, y:524},
            {x:8, y:460},
            {x:8, y:330},
        ],
        right_billets_coords: [
            {x:1138, y:395},
            {x:1138, y:200},
            {x:1138, y:589},
            {x:1138, y:135},
            {x:1138, y:654},
            {x:1138, y:524},
            {x:1138, y:265},
            {x:1138, y:460},
            {x:1138, y:330},
        ],
        systemaTextColor : 0x000000,
        terminalTextColor : 0x000000,
        /*left_billets_whole : {
            name : 'left_billets_whole.png',
            pos : [ 0, 25 ],
        },
        animation_offsets:[
            {x:0, y:0},
            {x:0, y:0},
            {x:0, y:0},
            {x:0, y:0},
            {x:0, y:0},
            {x:0, y:0},
            {x:0, y:0},
            {x:0, y:0},
            {x:0, y:0},
            {x:0, y:0},
            {x:0, y:0},
        ],*/
    },
    ui : {
        common: {
            font:'yello_dig',
        },
        buttons: {
            spin: {
                frames:{
                    normal : 'res/games/ui/rezultat_on.png',
                    disabled : 'res/games/ui/rezultat_of.png',
                },
                position:{x : 1447, y : 763 },
            },
            collect: {
                frames:{
                    normal : 'res/games/ui/rezultat_on.png',
                    disabled : 'res/games/ui/rezultat_of.png',
                },
                position:{x : 1447, y : 763 },
            },
            start: {
                frames:{
                    normal : 'res/games/ui/auto_on.png',
                    disabled : 'res/games/ui/auto_of.png',
                },
                position:{ x : 1321, y : 763 },
            },
            finish: {
                frames:{
                    normal : 'res/games/ui/exit_pari_on.png',
                    disabled : 'res/games/ui/exit_pari_of.png',
                },
                position:{x: 9, y : 5 },
            },
            info: {
                frames:{
                    normal : 'res/games/ui/info_on.png',
                    disabled : 'res/games/ui/info_off.png',
                },
                position:{x : 1056, y : 6 },
            },
            sound_on: {
                frames:{
                },
                position:{x : 0, y : 0}
            },
            sound_off: {
                frames:{
                },
                position:{x : 0, y : 0 }
            },
            gamble: {
                frames:{
                    normal : 'res/games/ui/auto_on.png',
                    disabled : 'res/games/ui/auto_of.png',
                },
                position:{ x : 1321, y : 763 },
            },
            betmax: {
                frames:{
                },
                position:{ x : 0, y : 0 },
            },
            betmin: {
                frames:{
                },
                position:{ x : 0, y : 0 },
            },
            autoplay: {
                frames:{
                    normal : 'res/games/ui/auto_on.png',
                    disabled : 'res/games/ui/auto_of.png',
                },
                position:{ x : 1321, y : 763 },
            },
            autoplayoff: {
                frames:{
                    normal : 'res/games/ui/auto_of.png',
                    disabled : 'res/games/ui/auto_on.png',
                },
                position:{ x : 1321, y : 763 },
            },
            menu: {
                frames:{
                    normal : 'res/games/ui/menu_on.png',
                    disabled : 'res/games/ui/menu_of.png',
                },
                position:{ x : 1192, y : 763 }
            },
            decrease_lines: {
                frames:{
                },
                position:{ x : 0, y : 0 },
            },
            increase_lines: {
                frames:{
                },
                position:{ x : 0, y : 0 },
            },
            lines: {
                frames:{
                },
                position:{ x : 0, y : 0 },
            },
            decrease_linebet: {
                frames:{
                },
                position:{ x : 0, y : 0 },
            },
            increase_linebet: {
                frames:{
                },
                position:{ x : 0, y : 0 },
            },
            linebet: {
                frames:{
                    normal : 'res/games/ui/size_step_on.png',
                    disabled : 'res/games/ui/size_step_of.png',
                },
                position:{ x : 1192, y : 823 },
            },
            next: {
                frames: {
                    normal : 'res/games/ui/help_next_on.png',
                    disabled : 'res/games/ui/help_next_off.png',
                },
                position:{ x : 788, y : 809 },
            },
            exit: {
                frames: {
                    normal : 'res/games/ui/help_back_on.png',
                    disabled : 'res/games/ui/help_back_off.png',
                },
                position:{ x : 20, y : 809 },
            },
            back: {
                frames: {
                    normal : 'res/games/ui/help_prev_on.png',
                    disabled : 'res/games/ui/help_prev_off.png',
                },
                position:{ x : 661, y : 809 },
            },
            visual_mode : {
                frames : {
                    normal : 'res/games/ui/visual_mode_on.png',
                    disabled : 'res/games/ui/visual_mode_of.png',
                },
                position : { x : 0, y : 700 },
            },

            risk_red: {
                frames:{
                    normal : 'res/games/ui/red_on.png',
                    disabled : 'res/games/ui/red_of.png',
                },
                position:{ x : 1192, y : 763 }
            },
            risk_black: {
                frames:{
                    normal : 'res/games/ui/black_on.png',
                    disabled : 'res/games/ui/black_of.png',
                },
                position:{ x : 1192, y : 823 },
            },

            end_pari: {
                frames:{
                    normal : 'res/games/ui/exit_pari_on.png',
                    disabled : 'res/games/ui/exit_pari_of.png',
                },
                position:{x: 9, y : 5 },
            },
        },
        frames: {
            lines:{
                text_position:{ x : 0, y : 0 },
                text_align : { x : 1.0, y : 0.0 },
                position : { x : 1161, y : 776 },
            },
            line_bet:{
                text_position:{ x : 0, y : 0 },
                text_align : { x : 1.0, y : 0.0 },
                position : { x : 1161, y : 805 },
            },
            win:{
                text_position:{ x : 0, y : 0 },
                text_align : { x : 1.0, y : 0.0 },
                position : { x : 1161, y : 860 }
            },
            total_bet:{
                text_position:{ x : 0, y : 0 },
                text_align : { x : 1.0, y : 0.0 },
                position : { x : 1161, y : 833 }
            },
            risk_step:{
                text_position:{ x : 0, y : 0 },
                text_align : { x : 1.0, y : 0.0 },
                position : { x : 1161, y : 833 }
            },
            risk_win:{
                text_position:{ x : 0, y : 0 },
                text_align : { x : 1.0, y : 0.0 },
                position : { x : 1161, y : 860 }
            },
            free_win: {
                frame:'res/games/ui/free_result.png',
                text_position:{x:213, y:11},
                text_align:{x:1.0, y:0.5},
                position:{x:11, y:855}
            },
            free_step_win: {
                text_position:{ x : 0, y : 0 },
                text_align : { x : 1.0, y : 0.0 },
                position : { x : 1161, y : 860 }
            }
            //TODO: минимальный шаг:
            /*min_step:{
                //font: 'userinterface_win-font',
                text_position:{x:44, y:37},
                text_align:{x:0.5, y:0.5},
                position:{x:469, y:699}
            },*/
        },
    },
    risk : {
        background : 'res/games/risk/risk_screen.png',
        background_position : { x : 0, y : 126 },
        table_background: 'res/games/risk/risk_table.png',
        table_background_position: { x : 0, y : 126 },
        currentWinLabel : {
            font : 'risk_result_font',
            position : { x : 120, y : 243 },
            align : 'left',
        },
        nextWinLabel : {
            font : 'risk_result_font',
            position : { x : 960, y : 243 },
            align : 'left',
        },
        currentStepLabel: {
            font : 'risk_step_font',
            position : { x : 895, y : 30 + 126 },
            align : 'central',
        },
        stepsLabel: {
            font : 'risk_step_font',
            position : { x : 989, y : 30 + 126 },
            align : 'central',
        },
        centralCard : {
            redShirt : 'res/games/risk/rubaska_big/rbr.png',
            blackShirt : 'res/games/risk/rubaska_big/rbb.png',
            position : { x : 496, y : 387 },
        },
        redButton : {
            state : {
                normal : 'res/games/risk/red_button.png',
                over : 'res/games/risk/red_button.png',
                pressed : 'res/games/risk/red_button.png',
                disabled : 'res/games/risk/red_button.png',
            },
            position : { x : 113, y : 426 },
        },
        blackButton : {
            state : {
                normal : 'res/games/risk/blue_button.png',
                over : 'res/games/risk/blue_button.png',
                pressed : 'res/games/risk/blue_button.png',
                disabled : 'res/games/risk/blue_button.png',
            },
            position : { x : 770, y : 426 },
        },
        history : {
            length : 6,
            suits : [
                'res/games/risk/masti/bubi.png',
                'res/games/risk/masti/bubi.png',
                'res/games/risk/masti/piki.png',
                'res/games/risk/masti/piki.png',
            ],
            cardScale : 1,
            position : { x : 319, y : 289 },
            cardOffset : 95,
        },
        suits : [
            'res/games/risk/card_red.png',
            'res/games/risk/card_red.png',
            'res/games/risk/card_black.png',
            'res/games/risk/card_black.png',
        ],
        check : 'res/games/risk/risk_check.png',
        light_plates: {
            name: 'res/games/risk/risk_table_light_part.png',
            //координаты относительно table_background
            x: 72,
            y: [190, 327],
        },
        tableCurrentStepLabel: {
            font : 'risk_table_step_font',
            position : { x : 797, y : 95 + 126 },
            align : 'central',
        },
        tableStepsLabel: {
            font : 'risk_table_step_font',
            position : { x : 865, y : 95 + 126 },
            align : 'central',
        },
        win_sound: 'res/games/sounds/risk_win',
        lose_sound: 'res/games/sounds/risk_lose',
        blink_sound: 'res/games/sounds/card_blink',
    },
    
    help : {
        pages: 34,
        pageNameFormat: "res/games/help/page_%03d.jpg",
        terminalTextColor : 0xffd580,
        terminal_position: {x: 1195, y: 843},
        paging_sound: 'res/games/sounds/help_paging',
    },
    
    cheque : {
        pari : '094099421747',
        event : '«Событие M15»',
        freegame_event : '«Событие M16»',
    },

    table : {
        background : 'res/games/table/background.png',
        combinationNameFormat : 'res/games/table/comby%02d.png',
        coloursCircleNameFormat : 'res/games/cheque/colours_circul/c%02d.png',
        scatterCircleName : 'res/games/cheque/colours_circul/c03.png',
        frameNameFormat : 'res/games/table/rc%02d.png',
        scatterFrameName : 'res/games/table/rc03.png',
        frameYPos : [ 211, 285, 359, 418, 477, 536, 595 ],
        scatterPrice: {
            wins:[2,3,4,5],
            position:{x:937, y:214}
        },
        priceTable: [
            {
                symbol:1,
                wins:[2,3,4,5],
                position:{x:1124, y:214}
            },
            {
                symbol:2,
                wins:[2,3,4,5],
                position:{x:937, y:287}
            },
            {
                symbol:3,
                wins:[2,3,4,5],
                position:{x:1124, y:287}
            },
            {
                symbol:4,
                wins:[3,4,5],
                position:{x:937, y:362}
            },
            {
                symbol:5,
                wins:[3,4,5],
                position:{x:1124, y:362}
            },
            {
                symbol:6,
                wins:[3,4,5],
                position:{x:937, y:421}
            },
            {
                symbol:7,
                wins:[3,4,5],
                position:{x:1124, y:421}
            },
            {
                symbol:8,
                wins:[3,4,5],
                position:{x:937, y:481}
            },
            {
                symbol:9,
                wins:[3,4,5],
                position:{x:1124, y:481}
            },
            {
                symbol:10,
                wins:[3,4,5],
                position:{x:937, y:539}
            },
            {
                symbol:11,
                wins:[3,4,5],
                position:{x:1124, y:539}
            },
            {
                symbol:12,
                wins:[2,3,4,5],
                position:{x:937, y:598}
            },
        ]
    },
    smallTicket : {
        balls_screen : 'res/games/small_ticket/balls_screen.png',
        miniballsNameFormat : 'res/games/small_ticket/miniballs/mb%02d.png',
        scatterBallName : 'res/games/small_ticket/miniballs/mb03.png',
        lines_choice : 'res/games/small_ticket/sat_%02d.png',
        risk_template : 'res/games/small_ticket/risk_screen%02d.png',
    },
    texts: {
        imgMain: 'res/games/game_text.png',
        posMain: {x: 1210, y: 119},
        imgRisk: 'res/games/risk_text.png',
        posRisk: {x: 1210, y: 119},
    }
}






// WEBPACK FOOTER //
// ./src/games/abstract.es6